module.exports = "../../../../platform/assets/pageMainIcon/ig-basic-archives-6.svg";